import { useState, useEffect } from 'react';

const LogoIntro = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    // Check if intro has been shown
    const hasSeenIntro = sessionStorage.getItem('vybe_intro_shown');
    
    if (hasSeenIntro) {
      setIsVisible(false);
      return;
    }

    // Start fade out after 3 seconds
    const timer = setTimeout(() => {
      setIsAnimating(false);
      setTimeout(() => {
        setIsVisible(false);
        sessionStorage.setItem('vybe_intro_shown', 'true');
      }, 1000);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-[#0A0A0A] flex items-center justify-center transition-opacity duration-1000 ${
        isAnimating ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {/* Animated background particles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-gradient-to-r from-[#FFD700]/20 to-[#FFA500]/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gradient-to-r from-[#C0C0C0]/10 to-[#FFD700]/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Logo with liquid gold effect */}
      <div className="relative z-10 text-center">
        <div className="relative inline-block">
          {/* Glow effect */}
          <div className="absolute inset-0 blur-2xl bg-gradient-to-r from-[#FFD700] via-[#FFA500] to-[#FFD700] opacity-50 animate-pulse"></div>
          
          {/* Main logo */}
          <h1 
            className="relative text-7xl md:text-9xl font-black bg-gradient-to-r from-[#FFD700] via-[#FFA500] to-[#FFD700] bg-clip-text text-transparent animate-shimmer"
            style={{ 
              fontFamily: 'Poppins, sans-serif',
              backgroundSize: '200% auto',
              animation: 'shimmer 3s linear infinite'
            }}
          >
            VYBE PARIS
          </h1>
          
          {/* Subtitle */}
          <p className="text-white/80 text-xl md:text-2xl mt-4 animate-fade-in" style={{ animationDelay: '0.5s' }}>
            Créateur d'expériences
          </p>
        </div>

        {/* Loading bar */}
        <div className="mt-12 w-64 h-1 bg-white/10 rounded-full overflow-hidden mx-auto">
          <div className="h-full bg-gradient-to-r from-[#FFD700] to-[#FFA500] animate-loading"></div>
        </div>
      </div>

      <style>{`
        @keyframes shimmer {
          0% { background-position: 0% center; }
          100% { background-position: 200% center; }
        }
        
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes loading {
          0% { width: 0%; }
          100% { width: 100%; }
        }
        
        .animate-shimmer {
          animation: shimmer 3s linear infinite;
        }
        
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
          opacity: 0;
        }
        
        .animate-loading {
          animation: loading 3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default LogoIntro;
